export default "__VITE_PUBLIC_ASSET__66f2def3__"